<template>
  <div class="custom-select w-100" ref="customSelect">
    <div class="select-header" :class="{ disabled: disable }" @click="toggleDropdown">
        <span v-if="selectedOption" class="py-1 px-2" :style="{
          backgroundColor: selectedOption.color,
          color: selectedOption.color ? '#fff' : '#606266',
          fontSize: selectedOption.color ? '10px' : '13px',
        }" style="border-radius: 4px;">
          {{ selectedOption.value }}
        </span>
        <span v-else :style="{
          fontSize: '13px',
          fontWeight: 400,
          color: '#b9bec6f3'
        }">
          {{ placeholder }}
        </span>

      <i v-if="selectedOption" class="el-icon-close" style="color: #c0c4cc" @click.stop="removeSelect"></i>
      <i v-else class="arrow" :class="{ open: isOpen }"></i>
    </div>
    <ul
      ref="dropdown"
      :class="[
        'select-dropdown',
        'w-100',
        { open: isOpen, 'open-above': openAbove }
      ]"
      :style="dropdownStyle"
      @scroll="handleDropdownScroll"
    >
      <!-- Search input trong dropdown -->
      <li v-if="isDropdownVisible" class="search-item" ref="searchItem" @click.stop>
        <input 
          v-model="searchText" 
          ref="searchInput" 
          class="search-input" 
          placeholder="Tìm kiếm..."
          @click.stop
        />
      </li>

      <li
        v-if="isDropdownVisible && virtualPaddingTop > 0"
        class="virtual-spacer"
        :style="{ height: virtualPaddingTop + 'px' }"
        aria-hidden="true"
      ></li>
      
      <li class="d-flex align-items-center justify-content-between" v-for="(option, index) in virtualOptions"
        :key="option.id || option.value || index" @click="selectOption(option)"
        :class="{ selected: option.id === selectedValue, color: option.color }">
        <span class="p-2" :style="{ backgroundColor: option.color ? option.color : '#909399' }">{{ option.value
          }}</span>
        <div class="material-icons" style="font-size: 16px; cursor: pointer; color: #327ae7"
          @click.stop="toggleVisibility(option)">
          visibility
        </div>
      </li>

      <li
        v-if="isDropdownVisible && virtualPaddingBottom > 0"
        class="virtual-spacer"
        :style="{ height: virtualPaddingBottom + 'px' }"
        aria-hidden="true"
      ></li>
      
      <!-- Thông báo khi không tìm thấy -->
      <li v-if="isDropdownVisible && visibleOptions.length === 0 && !showAll" class="no-result">
        Không tìm thấy kết quả
      </li>
      
      <li v-if="isVisible && !showAll" style="position: relative; z-index: 99999" @click="displayAll()">
        <span class="option-label" style="color: #000">Hiển thị các trường đã ẩn</span>
      </li>
      <div v-if="showAll">
        <li class="d-flex align-items-center justify-content-between" style="cursor: no-drop;"
          v-for="(option, index) in visibleOffOptions" :key="index" :class="{
            selected: option.id === selectedValue,
            color: option.color,
          }">
          <span class="p-2" :style="{
            backgroundColor: option.color ? option.color : '#909399',
          }">{{ option.value }}</span>
          <div class="material-icons" style="font-size: 16px; cursor: pointer" @click.stop="toggleVisibility(option)">
            visibility
          </div>
        </li>
        <li style="position: relative; z-index: 99999" @click="collapse()">
          <span class="option-label" style="color: #000">Thu gọn</span>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      required: false,
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
    disable: {
      type: Boolean,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    companyCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedValue: this.value,
      hiddenOptionsIds: this.getStoredHiddenOptions(),
      isVisible: this.getStoredIsVisible(),
      showAll: false,
      searchText: '',
      openAbove: false,
      dropdownMaxHeight: 250,
      defaultDropdownMaxHeight: 250,
  lastDropdownHeight: 250,
      optionItemHeight: 40,
      bufferItems: 5,
      virtualStartIndex: 0,
      virtualEndIndex: 0,
      searchRowHeight: 0,
      visibleItemsPerViewport: 0,
      dropdownTransitionDuration: 200,
      closeTimer: null,
      isClosing: false,
    };
  },
  computed: {
    visibleOptions() {
      const filtered = this.options.filter(
        (option) => !this.hiddenOptionsIds.includes(option.id)
      );
      
      if (!this.searchText || this.searchText.trim() === '') {
        return filtered;
      }
      
      const searchLower = this.searchText.trim().toLowerCase();
      return filtered.filter((option) => 
        option.value.toLowerCase().includes(searchLower)
      );
    },
    visibleOffOptions() {
      const hidden = this.options.filter((option) =>
        this.hiddenOptionsIds.includes(option.id)
      );
      
      if (!this.searchText || this.searchText.trim() === '') {
        return hidden;
      }
      
      const searchLower = this.searchText.trim().toLowerCase();
      return hidden.filter((option) => 
        option.value.toLowerCase().includes(searchLower)
      );
    },
    selectedOption() {
      return this.options.find((option) => option.value === this.value);
    },
    dropdownStyle() {
      return {
        '--dropdown-max-height': `${this.dropdownMaxHeight}px`,
      };
    },
    isDropdownVisible() {
      return this.isOpen || this.isClosing;
    },
    virtualOptions() {
      if (!Array.isArray(this.visibleOptions)) return [];
      return this.visibleOptions.slice(this.virtualStartIndex, this.virtualEndIndex);
    },
    virtualPaddingTop() {
      return this.virtualStartIndex * this.optionItemHeight;
    },
    virtualPaddingBottom() {
      const total = this.visibleOptions.length;
      const rendered = this.virtualOptions.length;
      return Math.max((total - this.virtualStartIndex - rendered) * this.optionItemHeight, 0);
    },
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    visibleOptions() {
      this.resetVirtualScroll();
    },
    isOpen(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateSearchRowHeight();
          this.initVirtualScroll();
        });
      }
    },
    dropdownMaxHeight() {
      this.updateVisibleItemCount();
    },
  },
  methods: {
    getStoredHiddenOptions() {
      const stored = JSON.parse(localStorage.getItem("hiddenOptions") || "{}");
      return (
        (stored &&
          stored[this.companyCode] &&
          stored[this.companyCode][this.code]) ||
        []
      );
    },
    getStoredIsVisible() {
      const stored = JSON.parse(localStorage.getItem("isVisible") || "{}");
      return (
        (stored &&
          stored[this.companyCode] &&
          stored[this.companyCode][this.code]) ||
        false
      );
    },
    saveHiddenOptions() {
      const stored = JSON.parse(localStorage.getItem("hiddenOptions") || "{}");
      if (!stored[this.companyCode]) {
        stored[this.companyCode] = {};
      }
      stored[this.companyCode][this.code] = this.hiddenOptionsIds;
      localStorage.setItem("hiddenOptions", JSON.stringify(stored));
    },
    saveIsVisible() {
      const stored = JSON.parse(localStorage.getItem("isVisible") || "{}");
      if (!stored[this.companyCode]) {
        stored[this.companyCode] = {};
      }
      stored[this.companyCode][this.code] = this.isVisible;
      localStorage.setItem("isVisible", JSON.stringify(stored));
    },
    displayAll() {
      // this.isVisible = false;
      // this.hiddenOptionsIds = [];
      this.showAll = true;
      this.saveHiddenOptions();
      this.saveIsVisible();
      document.removeEventListener("click", this.handleClickOutside);
      this.openDropdown({ preserveSearch: true });
      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside);
      }, 200);
    },
    collapse() {
      this.showAll = false;
      document.removeEventListener("click", this.handleClickOutside);
      this.openDropdown({ preserveSearch: true });
      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside);
      }, 200);
    },
    toggleVisibility(option) {
      if (this.hiddenOptionsIds.includes(option.id)) {
        this.hiddenOptionsIds = this.hiddenOptionsIds.filter(
          (id) => id !== option.id
        );
      } else {
        this.hiddenOptionsIds.push(option.id);
      }
      if (this.hiddenOptionsIds.length == 0) {
        this.showAll = false;
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
      this.saveHiddenOptions();
      this.saveIsVisible();
      // this.removeSelect()
    },
    toggleDropdown() {
      if (this.disable) return;
      if (this.isOpen) {
        this.searchText = '';
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    },
    selectOption(option) {
      if (this.disable) return;
      this.selectedValue = option.value;
      this.$emit("input", this.selectedValue);
      this.closeDropdown();
      this.searchText = '';
    },
    handleClickOutside(event) {
      const rootEl = this.$refs.customSelect;
      if (rootEl && !rootEl.contains(event.target)) {
        this.closeDropdown();
        this.searchText = '';
      }
    },
    removeSelect() {
      if (this.disable) return;
      this.selectedValue = "";
      this.$emit("input", this.selectedValue);
      this.searchText = '';
      this.openDropdown();
    },
    openDropdown({ preserveSearch = false } = {}) {
      if (this.disable) return;
      if (!preserveSearch) {
        this.searchText = '';
      }
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.isClosing = false;
      this.precomputeDropdownPosition();
      this.isOpen = true;
      this.$nextTick(() => {
        this.focusSearchInput();
        this.adjustDropdownPosition();
        this.initVirtualScroll();
      });
    },
    closeDropdown() {
      if (!this.isOpen && !this.closeTimer && !this.isClosing) return;
      this.isOpen = false;
      this.isDropdownVisible = false;
      this.isClosing = true;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
      }
      this.closeTimer = setTimeout(() => {
        this.openAbove = false;
        this.dropdownMaxHeight = this.defaultDropdownMaxHeight;
        this.isClosing = false;
        this.closeTimer = null;
      }, this.dropdownTransitionDuration);
    },
    focusSearchInput() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }
    },
    adjustDropdownPosition() {
      if (!this.isOpen) return;
      if (typeof window === 'undefined') return;
      const selectEl = this.$refs.customSelect;
      const dropdownEl = this.$refs.dropdown;
      if (!selectEl) return;
      const rect = selectEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      const dropdownContentHeight = dropdownEl ? dropdownEl.scrollHeight : this.defaultDropdownMaxHeight;
      let openAbove = false;
      if (spaceBelow < dropdownContentHeight && spaceAbove > spaceBelow) {
        openAbove = true;
      }
      const padding = 16;
      const availableSpace = openAbove ? spaceAbove : spaceBelow;
      let computedHeight = this.defaultDropdownMaxHeight;
      if (availableSpace > padding) {
        computedHeight = Math.min(this.defaultDropdownMaxHeight, availableSpace - padding);
      }
      this.dropdownMaxHeight = computedHeight > 0 ? computedHeight : this.defaultDropdownMaxHeight;
      this.openAbove = openAbove;
      if (dropdownEl) {
        const actualHeight = Math.min(dropdownEl.scrollHeight, this.dropdownMaxHeight);
        this.lastDropdownHeight = actualHeight || this.dropdownMaxHeight;
      }
    },
    precomputeDropdownPosition() {
      if (typeof window === 'undefined') return;
      const selectEl = this.$refs.customSelect;
      if (!selectEl) return;
      const rect = selectEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      const estimatedHeight = this.lastDropdownHeight || this.defaultDropdownMaxHeight;
      let openAbove = false;
      if (spaceBelow < estimatedHeight && spaceAbove > spaceBelow) {
        openAbove = true;
      }
      const padding = 16;
      const availableSpace = openAbove ? spaceAbove : spaceBelow;
      let computedHeight = this.defaultDropdownMaxHeight;
      if (availableSpace > padding) {
        computedHeight = Math.min(this.defaultDropdownMaxHeight, availableSpace - padding);
      }
      this.openAbove = openAbove;
      this.dropdownMaxHeight = computedHeight > 0 ? computedHeight : this.defaultDropdownMaxHeight;
    },
    handleViewportChange() {
      if (!this.isOpen) return;
      this.adjustDropdownPosition();
    },
    initVirtualScroll() {
      const dropdown = this.$refs.dropdown;
      if (dropdown) {
        dropdown.scrollTop = 0;
      }
      this.searchRowHeight = this.$refs.searchItem ? this.$refs.searchItem.offsetHeight : 0;
      this.updateVisibleItemCount();
      this.resetVirtualScroll();
    },
    updateVisibleItemCount() {
      const viewportItems = Math.ceil(this.dropdownMaxHeight / this.optionItemHeight) + this.bufferItems;
      this.visibleItemsPerViewport = Math.max(viewportItems, this.bufferItems);
    },
    resetVirtualScroll() {
      const total = this.visibleOptions.length;
      this.virtualStartIndex = 0;
      this.virtualEndIndex = Math.min(total, this.visibleItemsPerViewport || total);
    },
    handleDropdownScroll(event) {
      if (!this.isOpen || !this.visibleItemsPerViewport) return;
      const target = event && event.target ? event.target : null;
      if (!target || target !== this.$refs.dropdown) return;
      const effectiveScroll = Math.max(target.scrollTop - this.searchRowHeight, 0);
      const startIndex = Math.floor(effectiveScroll / this.optionItemHeight);
      if (startIndex === this.virtualStartIndex) return;
      const total = this.visibleOptions.length;
      const clampedStart = Math.max(0, Math.min(startIndex, total));
      const nextEnd = Math.min(total, clampedStart + this.visibleItemsPerViewport);
      this.virtualStartIndex = clampedStart;
      this.virtualEndIndex = nextEnd;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleViewportChange);
      window.addEventListener('scroll', this.handleViewportChange, true);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleViewportChange);
      window.removeEventListener('scroll', this.handleViewportChange, true);
    }
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  cursor: pointer;
  height: 32px;
}

.select-header {
  height: 32px;
  border: 1px solid #dcdfe6;
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.select-header[disabled] {
  background: #f5f7fa;
  cursor: not-allowed;
  color: #c0c4cc;
}

.select-header .filter-input {
  flex: 1;
}

.select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-top: 0;
  margin-bottom: 0;
  z-index: 10;
  list-style: none;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.select-dropdown.open {
  overflow-y: auto;
  max-height: var(--dropdown-max-height, 250px);
  opacity: 1;
}

.select-dropdown.open-above {
  top: auto;
  bottom: calc(100% + 4px);
  margin-bottom: 0;
}

.select-dropdown li {
  padding: 12px 20px;
}

.virtual-spacer {
  padding: 0 !important;
  margin: 0;
  border: none;
  pointer-events: none;
}

.select-dropdown li span {
  border-radius: 4px;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
}

.select-dropdown li:hover {
  background: #f5f7fa;
}

.select-dropdown li.selected {
  background: #e6f7ff;
}

.select-header span {
  font-size: 13px;
  padding: 0 0 0 8px;
  font-weight: 400;
  color: #b9bec6f3;
}

.arrow {
  position: relative;
  top: -2px;
  right: 4px;
  border: solid #dcdfe6;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  transition: transform 0.2s;
}

.arrow.open {
  top: 2px;
  transform: rotate(-135deg);
}

.filter-input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
  background: transparent;
  padding: 0;
  margin: 0;
}

.search-item {
  padding: 8px 12px !important;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
  border-bottom: 1px solid #dcdfe6;
}

.search-input {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
}

.search-input:focus {
  border-color: #409eff;
}

.no-result {
  text-align: center;
  color: #909399;
  padding: 12px;
  font-size: 13px;
}
</style>
